export const AZURE_DOMAIN = 'app/modules/Contents/AZURE_DOMAIN';

export const PUT_MSAL_CONTEXT = 'app/modules/Contents/PUT_MSAL_CONTEXT';
